class hnGallery extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.loop = (this.getAttribute('data-loop') === 'true') ? true : false;
    let self = this;
    this.initSlider(self);
    this.addSpecialEvents(self);
    if(!self.loop) {
      this.addEventSliderLast(self)
    }
  }

  addEventSliderLast(self) {
    let wrapElement = self.querySelector('.gallery-items');
    if(wrapElement) {
      let items = wrapElement.querySelectorAll('.gallery-item');
      if(items.length > 0) {
        let item = items[items.length - 1];
        item.addEventListener('click', function() {
          if(!item.classList.contains('swiper-slide-active-fake')) {
            item.classList.add('swiper-slide-active-fake');
          } else {
            item.classList.toggle('active-two');
          }
          if(!wrapElement.querySelector('.swiper-slide-active').classList.contains('active-two')) {
            wrapElement.querySelector('.swiper-slide-active').classList.add('active-two')
          }
        })
      }
    }
  }

  initSlider(self) {
    let init = false,sectionId = this.sectionId , swiper;
    function swiperCard() {
      if (window.innerWidth < 990) {
        if (!init) {
          init = true;
          swiper = new Swiper(`.swiper-gallery-${sectionId}`, {
            slidesPerView: "auto",
            spaceBetween: 8,
            loop: self.loop,
            navigation: {
              nextEl: `.swiper-button-next-${sectionId}`,
              prevEl: `.swiper-button-prev-${sectionId}`,
            },
            scrollbar: {
              el: `.swiper-scrollbar-${sectionId}`,
              draggable: true,
              dragSize: 237
            },
            on: {
              click(event) {
                if(swiper.activeIndex !== this.clickedIndex) {
                  let el = this.el;
                  let btnNext = el.querySelector('.swiper-button-next');
                  if(btnNext) {
                    btnNext.click()
                  }
                } else {
                  event.clickedSlide.classList.toggle('active-two');
                }
              },
            },
          });
        }
      } else if (init) {
        swiper.destroy();
        init = false;
      }
    }
    swiperCard();
    window.addEventListener("resize", swiperCard);
    console.log('innit Slider')
  }

  addSpecialEvents(self) {
    self.querySelectorAll('a[href="#login"]').forEach(item => {
      item.setAttribute('data-popup-account','')
      item.classList.add('benefits-table__button-login')
    });
    self.querySelectorAll('a[href="#registration"]').forEach(item => {
        item.setAttribute('data-popup-account','')
      item.classList.add('benefits-table__button-regis')
    });
    self.querySelectorAll('a[href="#footer_newsletter"]').forEach(item => {
      item.addEventListener('click', function() {
        document.querySelector('.rocket-footer__container').scrollIntoView({ behavior: 'smooth' })
      })
    });
  }
}
customElements.define('hn-gallery', hnGallery)